<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<mat-expansion-panel id="accessorials" class="bordered accessorials" [formGroup]="shipment.shipmentForm">
   <mat-expansion-panel-header>
      <mat-panel-title>
         Accessorials
      </mat-panel-title>
   </mat-expansion-panel-header>

   <ng-container color="primary" *ngIf="filteredAccessorials$ | async as accs; else spinner">
      <div class="two-row">
         <mat-form-field>
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="searchTerm" (input)="onSearch($event)" [required]="false" name="accessorialSearch" [ngModelOptions]="{ standalone: true }"/>
            <button *ngIf="searching" mat-icon-button matSuffix (click)="clearSearch()">
               <mat-icon>clear</mat-icon>
            </button>
         </mat-form-field>
         
         <div class="selected-chips-container" *ngIf="getSelectedAccessorials().length > 0">
            <mat-chip-list class="selected-chips">
               <mat-chip class="mat-chips"
                  *ngFor="let selected of getSelectedAccessorials(); trackBy: trackByCode"
                  [removable]="true"
                  (removed)="removeSelection(selected)">
                  {{ selected.description | titlecase }}
                  <mat-icon matChipRemove>cancel</mat-icon>
               </mat-chip>
            </mat-chip-list>
         </div>
      </div>

      <div class="checkbox-container">
         <div class="checkbox-item" *ngFor="let service of accs; trackBy: trackByCode">
            <mat-checkbox 
               [color]="primaryColor" 
               [checked]="isSelected(service)"
               (change)="onSelectionChange(service, $event.checked)">
               {{ service.description | titlecase}}
            </mat-checkbox>
         </div>
         <div *ngIf="!searching">
            <a class="see-more" (click)="toggleSeeMore()" *ngIf="accessorials.length > 0">
               {{ showAll ? '- Less' : '+ More' }}
            </a>
         </div>
      </div>
   </ng-container>

   <!-- <button type="button" (click)="submit()" [disabled]="getSelectedAccessorials().length === 0">
      Submit ({{ getSelectedAccessorials().length }} selected)
   </button> -->
</mat-expansion-panel>